import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AiChatResponse, AiMessage } from '../models/ai-message.model';

@Injectable({
  providedIn: 'root'
})
export class AiService {
  constructor(private http: HttpClient) {}

  chat(courseId: number, message: string, history: AiMessage[]): Observable<AiChatResponse> {
    const cleanHistory = history.map(({ role, content }) => ({ role, content }));
    return this.http.post<AiChatResponse>(
      environment.apiUrl + `/courses/${courseId}/ai/chat`,
      { message, history: cleanHistory }
    );
  }
}
